module.exports = __webpack_public_path__ + "static/images/livestream.dd7fcf36b8a0240dfe2045e5ca7dae77.svg";